import SolicitacaoPagamentoPj from './componentes/SolicitacaoPagamentoPj.vue';
import SolicitacaoPagamentoPjLista from './componentes/SolicitacaoPagamentoPjLista.vue';
import SolicitacaoPagamentoPjForm from './componentes/SolicitacaoPagamentoPjForm.vue';
import SolicitacaoPagamentoRelatorio from './componentes/SolicitacaoPagamentoRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-pj',
  component: SolicitacaoPagamentoPj,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoPjLista,
      name: 'solicitacao-pagamento-pj',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoPjForm,
      name: 'solicitacao-pagamento-pj.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoRelatorio,
      name: 'solicitacao-pagamento-pj.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoPagamentoPjForm,
      name: 'solicitacao-pagamento-pj.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/juridica/rotas.js